import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { FullscreenModal } from './fullscreen-modal';

interface ImagePreviewProps {
  fileUrl: string;
  fileName: string;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({ fileUrl, fileName }) => {
  const { t } = useTranslation();
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleFullscreenClick = () => {
    setIsFullscreen(true);
  };

  const handleCloseFullscreen = () => {
    setIsFullscreen(false);
  };

  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-gray-50/70">
      <div className="relative">
        <div className="relative group">
          <img
            src={fileUrl}
            alt="File preview"
            className="max-w-full max-h-64 object-contain rounded-lg shadow-sm border border-gray-200"
          />
          {/* Fullscreen button overlay */}
          <button
            type="button"
            onClick={handleFullscreenClick}
            className="absolute top-2 right-2 p-2 bg-black bg-opacity-50 text-white rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
            title={t('forms.openInFullscreen')}
          >
            <Icon icon="mdi:fullscreen" className="text-lg" />
          </button>
        </div>
        <div className="mt-2 flex items-center justify-between">
          <div className="text-xs text-gray-500 truncate flex-1" title={fileName}>
            {fileName}
          </div>
          <button
            type="button"
            onClick={handleFullscreenClick}
            className="ml-2 px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs hover:bg-purple-200 transition-colors"
            title={t('forms.openInFullscreen')}
          >
            <Icon icon="mdi:fullscreen" className="text-sm" />
          </button>
        </div>
      </div>

      {/* Fullscreen Modal */}
      <FullscreenModal
        isOpen={isFullscreen}
        onClose={handleCloseFullscreen}
        title={`Image - ${fileName}`}
      >
        <div className="h-full flex items-center justify-center bg-gray-100">
          <img
            src={fileUrl}
            alt="Fullscreen preview"
            className="max-w-full max-h-full object-contain rounded-lg shadow-lg"
          />
        </div>
      </FullscreenModal>
    </div>
  );
};


